import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promotiondetails-grid',
  templateUrl: './promotiondetails-grid.component.html',
  styleUrls: ['./promotiondetails-grid.component.css']
})
export class PromotiondetailsGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/serviceregister/promotiondetails/promotiondetails-grid/promotiondetails-grid.component.ts